import React, {useState, useEffect} from "react";

import "./style.css";

import Geolocalizacao from "../../components/Geolocalizacao";
import { Loading } from "../Routes";
import api, { MENSAGEM_ERRO_HTTP } from "../../services/api";
import { getParam, mensagemErro, mensagemSucesso } from "../../library";
import Lottie from "lottie-react";
import animationLocationOn from "../../assets/lottie/location_on.json";

const ConfirmaChegada = () => {
    const [loading, setLoading] = useState(false);
    const [geolocalizacao, setGeolocalizacao] = useState(null);
    const [erroGeolocalizacao, setErroGeolocalizacao] = useState("Erro ao obter sua localização.");
    const [coordenada, setCoordenada] = useState({});

    async function handleConfirmaChegada() {
        let response;
        
        try {
            setLoading(true);            
            response = await (await api.post(
            "/site-atendimento/inclui-fila-atendimento", 
            {
                codLocal: getParam("codLocal"),
                codMarcacao: getParam("codMarcacao"),
                hash: getParam("hash"),
                origem: "SITE",
                latitude: coordenada?.latitude ? coordenada?.latitude : 0,
                longitude: coordenada?.latitude ? coordenada?.longitude : 0
            }
            )).data;     
            
            if (response?.error) {
                if (response?.messageName)
                    mensagemErro(
                        "", 
                        `
                        <div class="swal2-html-container">
                        <span><b>${response.messageName}</b>, ${response.messageText}</span>
                        </div>
                        `, 
                        true,
                        () => {}
                    );
                else
                    mensagemErro("", response?.message, false, () => {});
            } else 
                mensagemSucesso(
                    "", 
                    `
                    <div class="swal2-html-container">
                    <span><b>${response?.messageName}</b>, ${response?.messageText}</span>
                    </div>
                    `, 
                    true,
                    () => {}
                );            
        } catch {
            MENSAGEM_ERRO_HTTP(null, () => {});
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    //console.log("Latitude: " + position.coords.latitude);
                    //console.log("Longitude: " + position.coords.longitude);
                    setGeolocalizacao(true);
                    setCoordenada(position?.coords);
                },
                function(error) {
                    setErroGeolocalizacao("Erro ao obter sua localização.");
                    setGeolocalizacao(false);
                    setCoordenada({});
                }
            );
        } else {
            setGeolocalizacao(false);
            setCoordenada({});
            setErroGeolocalizacao("Geolocalização não suportada pelo navegador.");
        }        
    }, []);

    if (loading) 
        return <Loading text="Confirmando sua chegada..."/>

    if (geolocalizacao === false)   
        return <Geolocalizacao erroGeolocalizacao={erroGeolocalizacao} />

    return (
        <div className="confirma-chegada-container">
            <div className="confirma-chegada-content">
                <Lottie 
                    animationData={animationLocationOn} 
                    autoplay={true}
                    style={{width: 120}}
                />

                <button className="confirma-chegada-botao" onClick={handleConfirmaChegada}>Confirma chegada</button>
            </div>
        </div>
    )
}

export default ConfirmaChegada;